import { IEtagerByggehojdeFilter, IBygOmfangFilter } from './interfaces/state';

// Toggles
export const TOGGLE_ANVENDELSE_FILTER = 'TOGGLE_ANVENDELSE_FILTER';
export const TOGGLE_MAX_HOJDE_FILTER = 'TOGGLE_MAX_HOJDE_FILTER';
export const TOGGLE_MAX_BYGPCT_FILTER = 'TOGGLE_MAX_BYGPCT_FILTER';
export const TOGGLE_PLANENS_ALDER_FILTER = 'TOGGLE_PLANENS_ALDER_FILTER';
export function setAnvendelseFilterToggled(toggled) {
  return { type: TOGGLE_ANVENDELSE_FILTER, toggled };
}
export function setMaxHojdeFilterToggled(toggled) {
  return { type: TOGGLE_MAX_HOJDE_FILTER, toggled };
}
export function setBygpctFilterToggled(toggled) {
  return { type: TOGGLE_MAX_BYGPCT_FILTER, toggled };
}
export function setPlanensAlderFilterToggled(toggled) {
  return { type: TOGGLE_PLANENS_ALDER_FILTER, toggled };
}

// Search Result
export const HOVER_SEARCH_RESULT = 'HOVER_SEARCH_RESULT';
export function setHoveredSearchResult(planid) {
  return { type: HOVER_SEARCH_RESULT, planid };
}

// Lokalplaner
export const TRIGGER_HISTORISKE_LOKALPLANER = 'TRIGGER_HISTORISKE_LOKALPLANER';
export function triggerHistoriskeLokalplaner(
  triggerHistoriskeLokalplaner: boolean
) {
  return { type: TRIGGER_HISTORISKE_LOKALPLANER, triggerHistoriskeLokalplaner };
}

// Filters
export const RESET_FILTERS = 'RESET_FILTERS';
export const TOGGLE_ANVGEN = 'TOGGLE_ANVGEN';
export const SET_TOGGLED_ANVSPECS = 'SET_TOGGLED_ANVSPECS';
export const SET_PLANENS_ALDER_FILTER = 'SET_PLANENS_ALDER_FILTER';
export const SET_BYGOMFANG_FILTER = 'SET_BYGOMFANG_FILTER';
export const SET_ETAGER_BYGGEHOJDE_FILTER = 'SET_ETAGER_BYGGEHOJDE_FILTER';

export function resetFilters() {
  return { type: RESET_FILTERS };
}
export function toggleAnvgen(kode: number) {
  return { type: TOGGLE_ANVGEN, kode };
}
export function setToggledAnvspecs(anvspecs: Array<number>) {
  return { type: SET_TOGGLED_ANVSPECS, anvspecs };
}
export function setPlanAlderFilter(planAlderFilter) {
  return { type: SET_PLANENS_ALDER_FILTER, planAlderFilter };
}
export function setBygOmfangFilter(bygOmfangFilter: IBygOmfangFilter) {
  return { type: SET_BYGOMFANG_FILTER, bygOmfangFilter };
}
export function setEtagerByggeHojdeFilter(
  etagerByggeHojdeFilter: IEtagerByggehojdeFilter
) {
  return { type: SET_ETAGER_BYGGEHOJDE_FILTER, etagerByggeHojdeFilter };
}

// Style
export const SET_ACTIVE_STYLE = 'SET_ACTIVE_STYLE';
export function setActiveStyle(activeStyle: string) {
  return { type: SET_ACTIVE_STYLE, activeStyle };
}

export const CLICKED_DELOMRAADE = 'CLICKED_DELOMRAADE';
export function clickedDelomraade(id: number) {
  return { type: CLICKED_DELOMRAADE, id };
}
export const CLICKED_BYGGEFELT = 'CLICKED_BYGGEFELT';
export function clickedByggefelt(id: number) {
  return { type: CLICKED_BYGGEFELT, id };
}
